 

class PlacementCommentDirective implements ng.IDirective {
        restrict = 'AE'
        controller = PlacementCommentController
        controllerAs = 'acCtrl'
        bindToController = true
        templateUrl = 'controls/placementComment/placementComment.html'
        scope = {
            applicationId: '='
        }
}

class PlacementCommentController {
    applicationId: number
    comments: any[];
    newComment: string;
    placementType: string = "P";

    static $inject = ['$rootScope', '$scope', 'ApplicationComments', 'Auth', 'dialogs'];
    constructor(private rootScope, private $scope, private ApplicationComments, private Auth, private dialogs) {

        $scope.$watch(() => this.applicationId, (newValue, oldValue) => {
            if (newValue) {
                this.refreshComments();
            }                
        });

        $scope.$on('applicationCommentsChange', (event, data) => {
            this.refreshComments();
        })
    }

    addComment() {
        this.ApplicationComments.save({
            applicationId: this.applicationId,
            comment: this.newComment,
            author: this.Auth.user.firstName + ' ' + this.Auth.user.lastName,
            commentType: this.placementType
        }).$promise
            .then(() => {
                this.newComment = "";
                this.rootScope.$broadcast('applicationCommentsChange', null);

                return this.refreshComments().$promise;
            }, () => {
                this.dialogs.error('Internal error', 'Error occured while saving placement comment. Please try again after a while.');
            });
    }

    refreshComments() {
        return this.ApplicationComments.query({
            applicationId: this.applicationId,
            type: this.placementType
        }, (result) => {
            this.comments = result;
        });
    }
}


angular
    .module('app')
    .directive('placementComment', () => new PlacementCommentDirective());